export default __webpack_public_path__ + "static/media/integration-banner.65e9b2b0.png";